import StatusMessage from '../components/StatusMessage';
import SchoolList from '../components/SchoolList';
import PrintingProgressGrid from '../components/PrintingProgressGrid';

function HomePage({
  user,
  onLogout,
  schoolsState,
  onSchoolSelect,
  canManagePrinting,
  printingProgressState,
  canManageAddEmail,
  addEmailProgressState,
  canManagePaperCat,
  paperCatProgressState,
  canManageEndAll,
  endAllProgressState,
  canViewDashboard,
  dashboardSummaryState,
}) {
  const { schools, status: schoolsStatus } = schoolsState;
 
  const shouldShowPrinting =
    canManagePrinting && printingProgressState?.progress?.length >= 0;
  const shouldShowAddEmail =
    !canManagePrinting &&
    canManageAddEmail &&
    addEmailProgressState?.progress?.length >= 0;
  const shouldShowPaperCat =
    !canManagePrinting &&
    !canManageAddEmail &&
    canManagePaperCat &&
    paperCatProgressState?.progress?.length >= 0;
  const shouldShowEndAll =
    !canManagePrinting &&
    !canManageAddEmail &&
    !canManagePaperCat &&
    canManageEndAll &&
    endAllProgressState?.progress?.length >= 0;
  const shouldShowDashboard =
    !canManagePrinting &&
    !canManageAddEmail &&
    !canManagePaperCat &&
    !canManageEndAll &&
    canViewDashboard &&
    dashboardSummaryState?.progress?.length >= 0;
 
  return (
    <div className="card home-card">


      <div className="actions-bar">
        <button type="button" className="secondary" onClick={onLogout}>
          تسجيل خروج
        </button>
      </div>

      {shouldShowPrinting && printingProgressState ? (
        <PrintingProgressGrid
          items={printingProgressState.progress}
          status={printingProgressState.status}
          onSelectSchool={onSchoolSelect}
          title="تقدم الطباعة"
          description="نسبة الإنجاز لكل مدرسة"
        />
      ) : shouldShowAddEmail && addEmailProgressState ? (
        <PrintingProgressGrid
          items={addEmailProgressState.progress}
          status={addEmailProgressState.status}
          onSelectSchool={onSchoolSelect}
          title="تقدم إضافة البريد"
          description="يتضمن عدد المستخدمين الذين تم تفعيل بريدهم الإلكتروني والمتبقين."
        />
      ) : shouldShowPaperCat && paperCatProgressState ? (
        <PrintingProgressGrid
          items={paperCatProgressState.progress}
          status={paperCatProgressState.status}
          onSelectSchool={onSchoolSelect}
          title="تقدم papercut"
          description="متابعة استكمال papercut للمدارس."
        />
      ) : shouldShowEndAll && endAllProgressState ? (
        <PrintingProgressGrid
          items={endAllProgressState.progress}
          status={endAllProgressState.status}
          onSelectSchool={onSchoolSelect}
          title="تقدم الإكمال النهائي"
          description="يعرض المدارس بحسب حالة الإكمال النهائي."
        /> 
      ) : shouldShowDashboard && dashboardSummaryState ? (
        <PrintingProgressGrid
          items={dashboardSummaryState.progress}
          status={dashboardSummaryState.status}
          onSelectSchool={onSchoolSelect}
          title="ملخص المدارس"
          description="عرض شامل لحالة المدارس حسب نقاط العمل المختلفة."
        /> 
      ) : (
        <section className="panel">
          <div className="panel-header">
            <h2>قائمة المدارس</h2>
            <span>اضغط على أي مدرسة للمتابعة</span>
          </div>
          <StatusMessage
            type={schoolsStatus?.type}
            message={schoolsStatus?.message}
          />
          {schoolsStatus?.type === 'success' && (
            <SchoolList schools={schools} onSelect={onSchoolSelect} />
          )}
        </section>
      )}
    </div>
  );
}

export default HomePage;

